export default "__VITE_ASSET__BkzRoj$W__"